import React from 'react';
import { BodyLargeEmphasized } from '../Typography';
import styles from './NavBar.styles';
import { PageTitleHelmet } from '@/components';
import { useGoogleTranslator } from '@/hooks';

interface Props {
  children: React.ReactNode;
}

export const NavBarDefault: React.FC<Props> = ({ children }) => {
  const titleTranslated = useGoogleTranslator(children as string);
  return (
    <header className={styles.container} data-testid="navbar">
      <PageTitleHelmet>{children}</PageTitleHelmet>
      <BodyLargeEmphasized data-testid="pageName" as='h1'>{titleTranslated}</BodyLargeEmphasized>
    </header>
  );
}
